import useCustomers from './useCustomers';

export default useCustomers;
